<div [class.keyValueCustom]="hasCustomValue"
     class="keyValue border-bottom">
  @if (icon) {
    <ix-icon [name]="icon" class="keyValueIcon"/>
  }
  <div class="keyValueContent">
    <ix-typography class="keyValueLabel" format="body" textColor="soft">
      {{ label }}
    </ix-typography>
    <div
      [class]="hasCustomValue && attribute && attribute.type.startsWith('list') ? 'keyValue-custom-content' : ''"
      class="flex-grow-1 w-100 d-flex flex-column gap-2">
      <ng-content class="flex-grow-1" select="[slot='custom-value']"/>
      @if (!hasCustomValue) {
        <ix-typography class="flex-grow-1" format="body">{{ value }}
        </ix-typography>
      }
    </div>
  </div>
</div>
